// A light tap the hand feels, for a choice that changes what the screen shows (Liam, 9 Oct 2026, the Diary's Day ·
// Week · Month: "could be more satisfying"). Android phones buzz briefly. An iPhone (Safari and the Roundly app,
// iOS 18 and later) gives its own light tap when a switch flips, so a hidden switch is flipped; older iPhones and
// computers feel nothing and nothing else happens. Call it from the tap itself: a phone only answers a person's tap.
let hidden: HTMLLabelElement | null = null

// Roundly's iPhone app (TestFlight, 10 Oct 2026) buzzes for the page itself, mid-gesture too (a slide crossing halfway),
// which a web page on an iPhone cannot. An older build of the app answers "Not available", and the page's own way below
// is used from then on.
type AppBridge = { call: (method: string, params?: unknown) => Promise<unknown> }
let appBuzz: boolean | null = null
function app(): AppBridge | null {
  const a = typeof window !== 'undefined' ? (window as unknown as { RoundlyIOS?: AppBridge }).RoundlyIOS : undefined
  return a && typeof a.call === 'function' ? a : null
}
if (app()) void app()!.call('app.info').then((info) => { appBuzz = !!(info as { haptics?: boolean } | null)?.haptics }).catch(() => { appBuzz = false })

export type Buzz = 'light' | 'medium' | 'success'
// The phone's tap for a moment: light for a choice, medium for crossing a point of no return, success for a payment.
export function buzz(style: Buzz): void {
  const a = app()
  if (a && appBuzz) { void a.call('haptic', { style }).catch(() => { appBuzz = false }); return }
  if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
    try { navigator.vibrate(style === 'success' ? [14, 50, 22] : style === 'medium' ? 14 : 8) } catch { /* no buzz */ }
    return
  }
  tick()
}

export function tick(): void {
  const a = app()
  if (a && appBuzz) { void a.call('haptic', { style: 'light' }).catch(() => { appBuzz = false }); return }
  try {
    if (typeof navigator.vibrate === 'function') { navigator.vibrate(8); return }
    if (!hidden || !hidden.isConnected) {
      const input = document.createElement('input')
      input.type = 'checkbox'
      input.setAttribute('switch', '')
      input.tabIndex = -1
      hidden = document.createElement('label')
      hidden.setAttribute('aria-hidden', 'true')
      hidden.className = 'roundly-haptic'
      hidden.style.cssText = 'position:fixed;left:-9999px;top:0;width:1px;height:1px;overflow:hidden;opacity:0;pointer-events:none'
      hidden.append(input)
      document.body.append(hidden)
    }
    hidden.click()
  } catch { /* A phone that refuses simply gives no tap. */ }
}
